// import selectedBox from '../components/selectedBox.vue'
import selectedBox from './../components/selectedBox.vue'
import viewRecord from '../components/viewPage.vue'
import salaryDateSearch from './../components/sentAtSearch.vue'
import salaryPView from '../components/salaryPView.vue'
import salaryTView from '../components/salaryTView.vue'
import store from '@/store'
import vue from 'vue'
const that = vue.prototype
export default {
  className: 'salary',
  perPage: 30,
  mixin: {
    fields: [
      {
        // 销售经理
        name: 'userId',
        note: '销售人员',
        search: {
          component: selectedBox
        },
      },
      // 用户所属公司
      {
        name: 'userCompany',
        note: '所属公司',
        width: 80,
      },
      {
        // 订单型号
        name: 'finishProductid',
        width: 80,
      },
      {
        // 客户
        name: 'clientid',
      },
      {
        // 吨数
        name: 'amount',
      },
      {
        // 售价
        name: 'sellingPrice',
        width: 80,
      },
      {
        // 成本
        name: 'costPrice'
      },
      {
        // 车间吨系数
        name: 'amountRatio1',
        width: 120,
      },
      {
        // 大类吨系数
        name: 'amountRatio2',
        width: 120,
      },

      {
        // 车间利系数
        name: 'profitRatio1',
        width: 120,
      },
      {
        // 大类利系数
        name: 'profitRatio2',
        width: 120,
      },
      {
        // 吨提成
        name: 'amountCommission',
      },
      {
        // 利润P
        name: 'profitP',
      },
      {
        // 利润T
        name: 'profitT',
      },
      {
        // 实际利润
        name: 'realProfit',
      },
      {
        // 订单工资P
        name: 'orderSalaryP',
        note: '工资P',
        view: {
          component: salaryPView
        },
      },
      {
        // 订单工资T
        name: 'orderSalaryT',
        note: '工资T',
        view: {
          component: salaryTView
        },
      },
      {
        name: 'sentAt',
        note: '日期',
        render: (record) => {
          return that.$tkDate(record.sentAt).format('yyyy-m')
        },
        search: {
          component: salaryDateSearch
        }
      },
    ],
    search: [
      'userId',
      'userCompany',
      'sentAt'
    ],
    action: {
      edit: false,
      create: false,
      delete: false,
      view: store.state.user && store.state.user.authority.salary.view ? {
        type: 'row',
        text: '查看',
        component: viewRecord
      } : false,
    },
    hooks: {
      beforeFetch ({ where }) {
        console.log(where)
        if (where.sentAt === 'null') { delete where.sentAt }
        if (where.userId === 'null') { delete where.userId }
        console.log(where)
        if (where.userId) {
          where.userId = {
            $in: where.userId
          }
        } else {
          if (store.state.user && store.state.user.allClient === 'No') {
            if (store.state.user.correlatedBy && store.state.user.correlatedBy.length) {
              where.userId = { $in: [store.state.user.objectId, ...store.state.user.correlatedBy] }
            } else {
              where.userId = store.state.user.objectId
            }
          }
        }
      }
    }
  }
}
